import { Space } from '@/types/space';
import { api } from './client';

export const spaceApi = {
  getAll: async (organisationId: string, isOnboarding = false): Promise<Space[]> => {
    if (isOnboarding) {
      return [{ ...fakeSpace, company_id: organisationId }];
    }
    const { data } = await api.get(`/companies/${organisationId}/workspaces`);
    return data.workspaces;
  },

  get: async (organisationId: string, spaceId: string, isOnboarding = false): Promise<Space> => {
    if (isOnboarding) {
      return { ...fakeSpace, company_id: organisationId };
    }
    const { data } = await api.get(`/companies/${organisationId}/workspaces/${spaceId}`);
    return data.workspace;
  },

  create: async (organisationId: string, name: string, imageId: string): Promise<Space> => {
    const { data } = await api.post(`/companies/${organisationId}/workspaces`, { name, image_id: imageId }, { headers: { 'Content-Type': 'multipart/form-data' } });
    return data.workspace;
  },

  update: async (organisationId: string, spaceId: string, name: string, imageId: string): Promise<Space> => {
    const { data } = await api.put(`/companies/${organisationId}/workspaces/${spaceId}`, { name, image_id: imageId });
    return data.workspace;
  },
}

const fakeSpace = {
  workspace_id: "a6c6df1e-6d44-47e9-9904-741254eb4ea0",
  creation_time: "2023-04-03T07:55:07+00:00Z",
  name: "Yuzu - Principal",
  image_id: null,
}